/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import VectorLayer from 'ol/layer/vector';
import { layer, mergeDescriptors, stylesContainer } from '../core';

/** @module vector-layer/layer */
/**
 * @vueProps
 */
var props = {
  /**
   * When set to `true`, feature batches will be recreated during animations.
   * @type {boolean}
   * @default false
   */
  updateWhileAnimating: Boolean,
  /**
   * When set to `true`, feature batches will be recreated during interactions.
   * @type {boolean}
   * @default false
   */
  updateWhileInteracting: Boolean,
  /**
   * Render mode for vector layers. Available values:
   * - `image` - vector layers are rendered as images
   * - `vector` - vector layers are rendered as vectors
   * @type {string}
   * @default vector
   */
  renderMode: {
    type: String,
    default: 'vector'
  }
  // todo implement options
  // renderOrder: Function,
  // renderBuffer: Number


  /**
   * @vueMethods
   */
};var methods = {
  /**
   * @return {ol.layer.Vector}
   * @protected
   */
  createLayer: function createLayer() {
    return new VectorLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      preload: this.preload,
      extent: this.extent,
      zIndex: this.zIndex,
      updateWhileAnimating: this.updateWhileAnimating,
      updateWhileInteracting: this.updateWhileInteracting,
      source: this._source,
      renderMode: this.renderMode
    });
  },

  /**
   * @returns {Object}
   * @protected
   */
  getServices: function getServices() {
    return mergeDescriptors(layer.methods.getServices.call(this), stylesContainer.methods.getServices.call(this));
  },

  /**
   * @return {ol.layer.Vector|undefined}
   * @protected
   */
  getStyleTarget: function getStyleTarget() {
    return this.$layer;
  }
};

/**
 * Layer for data that is rendered client-side.
 *
 * @vueProto
 * @title vl-layer-vector
 * @alias module:vector-layer/layer
 *
 * @vueSlot default Default slot for `vl-source-*` (vector-like only) components.
 */
var Layer = {
  name: 'vl-layer-vector',
  mixins: [layer, stylesContainer],
  props: props,
  methods: methods
};

/** @module vector-layer */
/**
 * @alias module:vector-layer
 *
 * @example Install
 * import Vue from 'vue'
 * // import module and styles
 * import { VectorLayer } from 'vuelayers'
 * // or
 * import VectorLayer from 'vuelayers/lib/vector-layer'
 * // import VueLayers styles
 * import 'vuelayers/lib/style.css'
 * // register components
 * Vue.use(VectorLayer)
 */
var index = {
  /**
   * Layer for data that is rendered client-side.
   * @alias module:vector-layer/layer
   */
  Layer: Layer,
  install: function install(Vue) {
    Vue.component(Layer.name, Layer);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/vector-layer/index.es.js
// module id = null
// module chunks = 